module.exports = "pegasus_template/assets/luna.png";